import { debounce } from "lodash";


const boundLog = console.log.bind(console, '[debounced]: ');
export const debouncedLog = debounce(boundLog, 200);
